import script from "./SummaryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryModal.vue?vue&type=script&setup=true&lang=js"

import "./SummaryModal.vue?vue&type=style&index=0&id=27cde0f0&scoped=true&lang=css"

import exportComponent from "/builds/sense/sense-signer/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cde0f0"]])

export default __exports__